export const MARKETPLACE_OPTIONS = [
	{ label: "Ticketmaster", value: "TICKETMASTER" },
	{ label: "StubHub", value: "STUBHUB" },
	{ label: "StubHub International", value: "STUBHUB_INT" },
	{ label: "SeatGeek", value: "SEATGEEK" },
	{ label: "Viagogo", value: "VIAGOGO" },
	{ label: "Vivid Seats", value: "VIVID_SEATS" },
	{ label: "Ticket Network", value: "TICKET_NETWORK" },
	{ label: "Ticket Evolution", value: "TICKET_EVOLUTION" },
	{ label: "TickPick", value: "TICK_PICK" },
	{ label: "GameTime", value: "GAME_TIME" },
	{ label: "FanXchange", value: "FAN_XCHANGE" },
	{ label: "AXS", value: "AXS" },
	{ label: "GoTickets", value: "GO_TICKETS" },
] as const;

export type Marketplace = (typeof MARKETPLACE_OPTIONS)[number]["value"];

export interface VenueAlias {
	id: number | string;
	name: string;
	marketplace: Marketplace;
	hitCount: number | null;
}

export interface VenueAliasGroup {
	id: number | string;
	sfVenueName: string;
	city: string;
	state: string;
	aliases: Array<VenueAlias>;
}

export interface MarketplaceVenueSearchResult {
	id: string;
	name: string;
	city: string;
	state: string;
	marketplace: Marketplace;
	hitCount: number | null;
}

export interface VenueAliasGroupsResponse {
	items: Array<VenueAliasGroup>;
	total: number;
}

export interface CityAlias {
	id: number | string;
	marketplaceId: number | null;
	marketplaceCity: string;
	stageFrontCity: string;
	state: string;
	createdBy: string;
	createdOn: string;
}

export interface CityAliasesResponse {
	items: Array<CityAlias>;
	total: number;
}
